import { render, staticRenderFns } from "./UnitsTabUnits.vue?vue&type=template&id=2b9f5b6f"
import script from "./UnitsTabUnits.vue?vue&type=script&lang=js"
export * from "./UnitsTabUnits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports